/** @format */

export const DEFAULT_TEST_ID = 'filter-results-summary';
